import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.maxLength = 7
    this.element.style.textTransform = "uppercase"
    this.element.addEventListener("input", this.format)
  }

  disconnect() {
    this.element.removeEventListener("input", this.format)
  }

  format = () => {
    let raw = this.element.value.replace(/\s/g, "").toUpperCase()
    if (raw.length > 3) {
      raw = raw.slice(0, 3) + " " + raw.slice(3)
    }
    if (raw.length > 7) {
      raw = raw.slice(0, 7)
    }
    this.element.value = raw
  }
}
